module.exports = "/static/media/energy_upgrade.c0aaf384.jpg";